import React from 'react';

import '../icon-component.scss';

const PreviewComponent = () => (
  <svg className="icon-component" viewBox="0 0 20 20">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <path d="M7.5,1.5 C10.8137085,1.5 13.5,4.1862915 13.5,7.5 C13.5,10.8137085 10.8137085,13.5 7.5,13.5 C4.1862915,13.5 1.5,10.8137085 1.5,7.5 C1.5,4.1862915 4.1862915,1.5 7.5,1.5 L7.5,1.5 Z M7.5,-1.77635684e-15 C3.35786438,-1.97215226e-31 0,3.35786438 0,7.5 C0,11.6421356 3.35786438,15 7.5,15 C11.6421356,15 15,11.6421356 15,7.5 C15,3.35786438 11.6421356,3.55271368e-15 7.5,3.55271368e-15 L7.5,3.55271368e-15 L7.5,-1.77635684e-15 Z" />
        <rect
          transform="translate(16.604935, 16.600000) rotate(-45.000000) translate(-16.604935, -16.600000) "
          x="15.854935"
          y="12.1"
          width="1.5"
          height="9"
          rx="0.75"
        />
      </g>
    </g>
  </svg>
);

PreviewComponent.displayName = 'PreviewIcon';

export default PreviewComponent;
